'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var riskfied = function () {
    return function (store) {
        return function (next) {
            return function (action) {
                switch (action.type) {
                    case '@@router/LOCATION_CHANGE':
                        if (typeof window !== 'undefined' && window.RISKX) {
                            var _action$payload = action.payload,
                                pathname = _action$payload.pathname,
                                search = _action$payload.search;

                            window.RISKX.go('' + pathname + search);
                        }
                        break;
                    default:
                        break;
                }
                return next(action);
            };
        };
    };
}();

exports.default = riskfied;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/middleware/riskified.js
// module id = cOev
// module chunks = 57